module.exports = __webpack_public_path__ + "img/table-gf.1019f357.svg";